<template>
  <Popup
    v-if="showAfterTourPopup"
    :name="popupName"
    :extra-classes="['popup--full-width-on-mobile']"
    :position="position"
    context="global"
    :show-close-button="true"
  >
    <template v-slot:content>
      <h3 class="after-tour__title" v-if="step === 0">
        {{ t('tour.afterTourPopupTitle') }}
      </h3>
      <div class="after-tour__content">
        <p v-if="step === 0">{{ t('tour.afterTourStep0') }}</p>
        <p v-if="step === 1">{{ t('tour.afterTourStep1') }}</p>
        <p v-if="step === -2">{{ t('tour.afterTourStepSwitch') }}</p>
        <p v-if="step === 2">
          {{ t('tour.afterTourStep2Prefix') }}
          <strong>
            <a
              href="https://www.efriends.at/fragen-antworten.html"
              target="_blank"
              >{{ t('tour.afterTourFaqLink') }}</a
            >
          </strong>
        </p>
      </div>

      <div class="after-tour__actions">
        <button
          v-if="step !== 2"
          class="button button--secondary"
          @click="setStep(step + 1)"
        >
          {{ t('tour.afterTourContinue') }}
        </button>
        <button
          v-if="step === 2"
          class="button button--secondary"
          @click="hidePopup()"
        >
          {{ t('tour.afterTourContinue') }}
        </button>
        <button class="button button--primary" @click="afterTourComplete()">
          {{ t('becomeEfriend.menuTitle') }}
        </button>
      </div>
    </template>
  </Popup>
</template>

<script setup>
  import { ref, computed } from 'vue'
  import Popup from '@/components/popups/Popup.vue'
  import { useAccountStore } from '@/stores/useAccountStore'
  import { useTourStore } from '@/stores/useTourStore'
  import { useRouter } from 'vue-router'
  import { useSpecificPopup } from '@/composables/useSpecificPopup.ts'
  import { useStrings } from '@/composables/useStrings.ts'
  import { storeToRefs } from 'pinia'

  const { t } = useStrings()
  const accountStore = useAccountStore()
  const tourStore = useTourStore()
  const { isDemoUser } = storeToRefs(accountStore)
  const router = useRouter()

  const popupName = 'afterTourExplanation'
  const afterTourExplanationPopup = useSpecificPopup(popupName)
  const newsletterPopup = useSpecificPopup('newsletterRequest')


  const step = ref(0)
  const position = computed(() => {
    switch (step.value) {
      case 0:
        return 'right center'
      case 1:
        return 'center bottom'
      case 2:
        return 'right top'
    }
  })

  const setStep = (value) => {
    step.value = value
  }

  const hidePopup = () => {
    tourStore.isAfterTourComplete = true
    afterTourExplanationPopup.hide()
    newsletterPopup.show()
  }

  const afterTourComplete = () => {
    hidePopup()
    router.push({
      name: 'choose-provider',
      params: {
        context: 'home',
      },
    })
  }

  const showAfterTourPopup = computed(() => {
    return (
      tourStore.isTourComplete &&
      isDemoUser.value &&
      !tourStore.isAfterTourComplete
    )
  })
</script>

<style lang="scss">
  .after-tour {
    &__actions {
      display: flex;
      justify-content: space-between;

      & > *:only-child {
        margin-left: auto;
      }

      &__title {
        display: flex;
        justify-content: space-between;
        line-height: 1.2;

        &--1 {
          font-size: 1.8rem;
        }
      }

      &__page {
        float: right;
        line-height: 1;
        padding-left: $spacer10;
        padding-bottom: $spacer20;
      }

      &__content,
      .button--no-padding {
        font-size: 0.8rem;

        @media (min-width: $bp-lg) {
          font-size: 1rem;
        }
      }
    }
  }
</style>
